<template>
  <el-button type="primary" @click="toggleExpand" class="w-full md:w-1/2 mt-2">
    <Icon
      :icon="isExpanded ? 'fa-solid:chevron-up' : 'fa-solid:chevron-down'"
      class="mr-4"
    />
    Payment Settings
  </el-button>
  <div
    ref="contentRef"
    :class="{
      'grid-expanded': isExpanded,
      'grid-collapsed': !isExpanded,
      'with-message': showRefreshMessage,
    }"
    class="grid overflow-hidden transition-all duration-500 ease-in-out bg-gray-900 rounded-br-lg rounded-bl-lg w-full md:w-1/2"
  >
    <div class="mx-auto my-auto w-full md:w-3/4">
      <SettingsConnectButton
        class="mt-4"
        :connected="userStore.settings.qbConnected"
        :connectFunction="handleQbConnect"
        :disconnectFunction="handleQbDisconnect"
        serviceName="QuickBooks"
      />

      <SettingsConnectButton
        class="mt-4"
        :comingsoon="true"
        :connected="userStore.settings.stripeConnected"
        :connectFunction="handleStripeConnect"
        :disconnectFunction="handleStripeDisconnect"
        serviceName="Stripe"
      />

      <SettingsConnectButton
        class="mt-4 mb-8"
        :comingsoon="true"
        :connected="userStore.settings.squareConnected"
        :connectFunction="square.getOAuthUrl"
        :disconnectFunction="square.disconnect"
        serviceName="Square"
      />
    </div>
  </div>
  <div v-if="showRefreshMessage" class="refresh-message mt-4">
    Please refresh this page after closing the new connection window.
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Icon } from "@iconify/vue";
import SettingsConnectButton from "./SettingsConnectButton.vue";
import { useUser, useStripe, useQb } from "@/stores";
import useExpandable from "@/composables/useExpandable";
import useSquare from "@/composables/useSquare";

const qb = useQb();
const userStore = useUser();
const stripe = useStripe();
const square = useSquare();
const { isExpanded, contentRef, toggleExpand } = useExpandable();

const showRefreshMessage = ref(false);

const handleQbConnect = async () => {
  showRefreshMessage.value = true;
  await qb.connectQb();
};

const handleQbDisconnect = async () => {
  showRefreshMessage.value = false;
  await qb.disconnectQb();
};

const handleStripeConnect = async () => {
  showRefreshMessage.value = true;
  await stripe.connectStripe();
};

const handleStripeDisconnect = async () => {
  showRefreshMessage.value = false;
  await stripe.disconnectStripe();
};
</script>

<style scoped>
.refresh-message {
  color: #ff4d4f;
  border-top: 1px solid #ff4d4f;
  padding-top: 8px;
  font-size: 0.9em;
  text-align: center;
}

.grid-expanded {
  grid-template-rows: 1fr;
}

.grid-collapsed {
  grid-template-rows: 0fr;
}

.grid-expanded > div,
.grid-collapsed > div {
  min-height: 0;
}
</style>
